import { useContext, useEffect, useState } from "react";
import "../../../../styles/workspace_styles/RootUserStyles/SystemAdministrators/EditSystemAdministrator.css";
import countries from "../../../../functions/getCountries";
import { SystemAdministratorContext } from "./SystemAdministratorProvider";
import { usersMicroserviceUrl } from "../../../../microservices/users_microservice";
import { AppContext } from "../../../AppProvider";

const EditSystemAdministrator = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        setReloadSystemAdministrators,
        selectedToEditSystemAdministrator,setSelectedToEditSystemAdministrator
    } = useContext(SystemAdministratorContext);
    const [firstName,setFirstName] = useState('');
    const [lastName,setLastName] = useState('');
    const [emailAddress,setEmailAddress] = useState('');
    const [selectedCountry,setSelectedCountry] = useState('');
    const [city,setCity] = useState('');
    const [phoneNumber,setPhoneNumber] = useState('');
    const [postalCode,setPostalCode] = useState('');
    const [address,setAddress] = useState('');
    const [address2,setAddress2] = useState('');

    const [showCountriesBrowser,setShowCountriesBrowser] = useState(false);
    const [countryFilterString,setCountryFilterString] = useState('');
    const [updateSystemAdministratorStatus,setUpdateSystemAdministratorStatus] = useState('');
    const updateSystemAdministrator = async () =>{
        setUpdateSystemAdministratorStatus('updating');
        try{
            const updateSystemAdministratorPayload = {
                firstName: firstName,
                lastName: lastName,
                emailAddress: emailAddress,
                country: selectedCountry,
                city:city,
                phoneNumber:phoneNumber,
                postalCode:postalCode,
                address:address,
                address2:address2
            }
            const url = `${usersMicroserviceUrl}/root/system-admins/${selectedToEditSystemAdministrator?.id}`;
            const response = await fetch(url,{
                method:'PATCH',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                },
                body:JSON.stringify(updateSystemAdministratorPayload)
            });
            if(response.ok){
                setUpdateSystemAdministratorStatus('updated');
                setReloadSystemAdministrators(true);
                return;
            }
            else if(response.status === 401) logout();
        }
        catch(error){
            console.error(`An error occcurred when updating system administrator with id ${selectedToEditSystemAdministrator?.id}:`,error)
        }
        setUpdateSystemAdministratorStatus('update-error');
    };
    const loadSystemAdministrator = () =>{
        setFirstName(selectedToEditSystemAdministrator?.firstName || '');
        setLastName(selectedToEditSystemAdministrator?.lastName || '');
        setEmailAddress(selectedToEditSystemAdministrator?.emailAddress || '');
        setSelectedCountry(selectedToEditSystemAdministrator?.country || '');
        setCity(selectedToEditSystemAdministrator?.city || '');
        setPhoneNumber(selectedToEditSystemAdministrator?.phoneNumber || '');
        setPostalCode(selectedToEditSystemAdministrator?.postalCode || '');
        setAddress(selectedToEditSystemAdministrator?.address || '');
        setAddress2(selectedToEditSystemAdministrator?.address2 || '');
    };
    const clearEditSystemAdministratorEntries = () =>{
        setCountryFilterString('');
        setShowCountriesBrowser(false);
        setFirstName('');
        setLastName('');
        setEmailAddress('');
        setSelectedCountry('');
        setCity('');
        setPhoneNumber('');
        setPostalCode('');
        setAddress('');
        setAddress2('');
        setUpdateSystemAdministratorStatus('');
    };
    const validFormToolTipText = () =>{
        if(firstName === '') return 'Enter the first name to proceed';
        if(lastName === '') return 'Enter the last name to proceed';
        if(emailAddress === '') return 'Enter a valid email address to proceed';
        if(selectedCountry === null) return "Select the user's country to proceed";
        if(city === '') return "Enter city name to proceed";
        return '';
    };
    const disposeWindow = () =>{
        clearEditSystemAdministratorEntries();
        setSelectedToEditSystemAdministrator(null);
    };
    useEffect(() =>{
        const handleEsc = (e) =>{
            if(e.key === "Escape" && (updateSystemAdministratorStatus === 'updated' || updateSystemAdministratorStatus === 'update-error')) disposeWindow();
        };
        document.addEventListener("keydown",handleEsc);
        return () =>{
            document.removeEventListener("keydown",handleEsc);
        };
    },[selectedToEditSystemAdministrator,updateSystemAdministratorStatus]);
    useEffect(() =>{
        loadSystemAdministrator();
    },[selectedToEditSystemAdministrator]);
    if(!selectedToEditSystemAdministrator) return null;
    return(
        <div className="root-user-edit-system-administrator-parent-container">
            {updateSystemAdministratorStatus === ''?
                (
                    <div className="root-user-edit-system-administrator-container">
                        <div className="root-user-edit-system-administrator-header">
                            <h1>Edit system administrator</h1>
                            <p onClick={() => disposeWindow()}>&#10006;</p>
                        </div>
                        <div className="root-user-edit-system-administrator-body">
                            <div className="root-user-edit-system-administrator-entry-container">
                                <p>First Name<span>*</span></p>
                                <input
                                    placeholder="Enter first name"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>
                            <div className="root-user-edit-system-administrator-entry-container">
                                <p>Last Name<span>*</span></p>
                                <input
                                    placeholder="Enter last name"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                            <div className="root-user-edit-system-administrator-entry-container">
                                <p>Email Address<span>*</span></p>
                                <input
                                    placeholder="Enter email address"
                                    value={emailAddress}
                                    onChange={(e) => setEmailAddress(e.target.value)}
                                />
                            </div>
                            <div className="root-user-edit-system-administrator-entry-container">
                                <p>Country<span>*</span></p>
                                {selectedCountry?
                                    (
                                        <div className="root-user-edit-system-administrator-selected-country-display">
                                            <p>{selectedCountry}</p>
                                            <p className="cancel-p" onClick={() => setSelectedCountry(null)}>&#10006;</p>
                                        </div>
                                    ):
                                    (
                                        <input
                                            placeholder="Select country"
                                            value={countryFilterString}
                                            onChange={(e) => setCountryFilterString(e.target.value)}
                                            onFocus={() => setShowCountriesBrowser(true)}
                                            onBlur={() => setTimeout(() => {setShowCountriesBrowser(false)},150)}
                                        />
                                    )
                                }
                                <div className={`root-user-edit-system-administrator-countries-browser ${showCountriesBrowser? 'active':''}`}>
                                    {[...countries].filter(country => country.toLowerCase().includes(countryFilterString?.toLowerCase())).
                                    sort((a,b) => a.localeCompare(b)).map((country) =>(
                                        <div key={country} onClick={() =>{
                                            setSelectedCountry(country);
                                            setCountryFilterString('');
                                        }}>{country}</div>
                                    ))}
                                </div>
                            </div>
                            <div className="root-user-edit-system-administrator-entry-container">
                                <p>City<span>*</span></p>
                                <input
                                    placeholder="Enter city"
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                />
                            </div>
                            <div className="root-user-edit-system-administrator-entry-container">
                                <p>Phone Number</p>
                                <input
                                    placeholder="Enter phone number"
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                            </div>
                            <div className="root-user-edit-system-administrator-entry-container">
                                <p>Postal Code</p>
                                <input
                                    placeholder="Enter postal code"
                                    value={postalCode}
                                    onChange={(e) => setPostalCode(e.target.value)}
                                />
                            </div>
                            <div className="root-user-edit-system-administrator-entry-container">
                                <p>Address</p>
                                <input
                                    placeholder="Enter address"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                            </div>
                            <div className="root-user-edit-system-administrator-entry-container">
                                <p>Address 2</p>
                                <input
                                    placeholder="Enter address 2"
                                    value={address2}
                                    onChange={(e) => setAddress2(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="root-user-edit-system-administrator-buttons-container">
                            <button className="cancel" onClick={() => disposeWindow()}>Cancel</button>
                            <button
                                className={`update ${validFormToolTipText() === ''? 'active':'inactive'}`}
                                title={validFormToolTipText()}
                                onClick={() =>{
                                    if(validFormToolTipText() !== '') return;
                                    updateSystemAdministrator();
                                }}>Update</button>
                        </div>
                    </div>
                ):updateSystemAdministratorStatus === 'updating'?
                (
                    <div className="root-user-edit-system-administrator-updating-container">
                        <div></div>
                        <p>Updating system administrator. Please wait...</p>
                    </div>
                ):updateSystemAdministratorStatus === 'updated'?
                (
                    <div className="root-user-edit-system-administrator-updated-container">
                        <div className="root-user-edit-system-administrator-updated-details-container">
                            <p>System administrator updated successfully</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="root-user-edit-system-administrator-updated-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):updateSystemAdministratorStatus === 'update-error'?
                (
                    <div className="root-user-edit-system-administrator-update-error-container">
                        <div className="root-user-edit-system-administrator-update-error-details-container">
                            <p>Unexpected error occurred when updating system administrator</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="root-user-edit-system-administrator-update-error-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):
                (<></>)
            }
        </div>
    );
};
export default EditSystemAdministrator;